// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3cQwO","search":"Settings_search__3UtAc","filter":"Settings_filter__FAZvE"};